import { createSelector } from 'reselect';
import { getLaborTicketModalOpen } from './getLaborTicketModalOpen';
import { getSelectOperatorOpen } from './getSelectOperator';
import { getClockOutModalOpen } from './getClockOutModalOpen';
import { getClockOutFlowOpen } from './getClockOutFlowOpen';
import { getSetupActionModalOpen } from './getSetupActionModalOpen';
import { getShiftHandoverOpen } from './getShiftHandoverOpen';
import { getShiftIntroOpen } from './getShiftIntroOpen';
import { getSelectActivityOpen } from './getSelectActivity';
import { getJobCloseAtDialogOpen } from './getJobCloseAtDialog';
import { getAnyOverlayOpen } from './getAnyOverlayOpen';

// True when the operator is in a focused flow/overlay on the machine home route
// where the downtime prompt must not interrupt them: labor ticket, operator
// sign-in, clock-out, setup, shift handover/intro, switch-activity, the job
// close-at dialog, and the APM job/work drawers tracked in openOverlayIds.
const getAnyOperatorFlowOpen = createSelector(
  [
    getLaborTicketModalOpen,
    getSelectOperatorOpen,
    getClockOutModalOpen,
    getClockOutFlowOpen,
    getSetupActionModalOpen,
    getShiftHandoverOpen,
    getShiftIntroOpen,
    getSelectActivityOpen,
    getJobCloseAtDialogOpen,
    getAnyOverlayOpen,
  ],
  (
    laborTicketModalOpen,
    selectOperatorOpen,
    clockOutModalOpen,
    clockOutFlowOpen,
    setupActionModalOpen,
    shiftHandoverOpen,
    shiftIntroOpen,
    selectActivityOpen,
    jobCloseAtDialogOpen,
    anyOverlayOpen
  ) => {
    return Boolean(
      laborTicketModalOpen ||
        selectOperatorOpen ||
        clockOutModalOpen ||
        clockOutFlowOpen ||
        setupActionModalOpen ||
        shiftHandoverOpen ||
        shiftIntroOpen ||
        selectActivityOpen ||
        jobCloseAtDialogOpen ||
        anyOverlayOpen
    );
  }
);

export { getAnyOperatorFlowOpen };
